import { User } from './user-model';

export const webhookEventTypes = [
  'item.created',
  'item.updated',
  'item.restored',
  'item.deleted',
] as const;

export type WebhookEventType = (typeof webhookEventTypes)[number];

export type WebhookDeliveryStatus = 'pending' | 'succeeded' | 'failed';

export type Webhook = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  user?: User;
  description: string;
  url: string;
  secret: string;
  events: WebhookEventType[];

  /**
   * The lists this webhook sends events for. Empty means every list
   */
  listIds: string[];
  activated: boolean;

  /**
   * Why JSONPad disabled this webhook, e.g. after too many failures
   */
  disabledReason: string | null;
  consecutiveFailures: number;
  lastDeliveryAt: Date | null;
  lastDeliveryStatus: WebhookDeliveryStatus | null;

  /**
   * Over the plan's webhook limit, so nothing is sent to it
   */
  locked: boolean;
  pendingDeliveries: number;
};

export type WebhookDelivery = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  webhookId: string;
  eventId: string;
  event: WebhookEventType | 'ping';
  listId: string | null;
  itemId: string | null;
  redeliveryOf: string | null;
  status: WebhookDeliveryStatus;
  attempts: number;
  nextAttemptAt: Date | null;
  lastAttemptAt: Date | null;
  responseStatus: number | null;
  responseBody: string | null;
  error: string | null;
  durationMs: number | null;
  completedAt: Date | null;

  /**
   * Only included when fetching a single delivery
   */
  payload?: Record<string, any>;
};

export type WebhookPingResult = {
  ok: boolean;
  status: number | null;
  error: string | null;
  durationMs: number;
  delivery: WebhookDelivery;
};

export const webhookOrderFields = [
  'createdAt',
  'updatedAt',
  'userId',
  'url',
] as const;

export type WebhookOrderField = (typeof webhookOrderFields)[number];
